import React from "react";

const RosterContext = React.createContext({});

export default RosterContext;
